export default "__VITE_ASSET__BakDIsIG__"